import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	productTeaser: {
		background: "#FAF3E4",
		color: theme.palette?.text?.secondary,
		display: "flex",
		flexDirection: "column",
		padding: theme.spacing(5),
		position: "relative",
		"&::before": {
			border: `1px solid #AFA08B`,
			bottom: 20,
			content: "''",
			left: 20,
			position: "absolute",
			right: 20,
			top: 20,
			zIndex: 1
		},
		"& .mco-shop-price": {
			"&__value": {
				color: theme.palette.text.secondary,
				fontSize: 32
			}
		},
		"&:hover .mco-shop-product-teaser__overlay": {
			opacity: 1
		}
	},
	image: {
		display: "flex",
		height: "100%",
		justifyContent: "center",
		maxHeight: 250,
		position: "relative",
		width: "auto",
		zIndex: 3
	},
	fallbackImage: {
		display: "flex",
		minHeight: "100%",
		paddingBottom: "144.6280991735537%",
		position: "relative",
		width: "100%",
		"& .mco-fallback-image": {
			background: "none",
			left: 0,
			position: "absolute",
			top: 0,
			"& img": {
				width: "100% !important"
			}
		}
	},
	content: {
		alignItems: "center",
		display: "flex",
		flex: 1,
		flexDirection: "column",
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		paddingTop: theme.spacing(3.75),
		textAlign: "center",
		[theme.breakpoints.up("sm")]: {
			paddingLeft: 0,
			paddingRight: 0
		}
	},
	title: {
		fontFamily: "Cochin, serif",
		fontSize: 35,
		hyphens: "auto",
		lineHeight: 1.2
	},
	year: {
		color: "#49401B"
	},
	attributes: {
		marginTop: theme.spacing(1.5),
		"& span": {
			fontWeight: theme.typography.fontWeightBold
		}
	},
	price: {
		marginTop: "auto",
		paddingTop: theme.spacing(1.5),
		"& .mco-shop-price__wrapper": {
			justifyContent: "center"
		}
	},
	button: {
		display: "block",
		marginTop: theme.spacing(4),
		position: "relative",
		width: "100%",
		zIndex: 5
	},
	overlay: {
		background: "rgba(73, 64, 27, 0.7)",
		bottom: 20,
		left: 20,
		opacity: 0,
		padding: theme.spacing(6, 3, 3),
		position: "absolute",
		right: 20,
		textAlign: "center",
		top: 20,
		transition: theme.transitions.create(["opacity"], {
			duration: theme.transitions.duration.shorter
		}),
		zIndex: 4
	},
	description: {
		color: "#FFFFFF",
		fontFamily: "Cochin, serif",
		fontWeight: 400
	},
	tag: {
		left: 35,
		position: "absolute",
		top: 35
	},
	bookmark: {
		right: 35,
		position: "absolute",
		top: 35,
		zIndex: 5
	}
}));

export default styles;
